// JavaScript Document Ph5 Settings (its_settings)
//components/signs/Ph5/Settings
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';
import Option from './setting/Form';
import OptionTable from './setting/Table'
//import TypesTable from './TypesTable';
//import CatTable from './CategoriesTable';
//import ClassTable from './ClassTable';
//import Category from './forms/Category';
//import SignClass from './forms/SignClass';
//import TypeForm from './forms/SignType';
//import TypeTable from './TypeTable';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
	maxHeight:'calc(100vh - 64px)',
	//maxHeight: '100%'
  },
  root: {
	  flexGrow: 1,
  },
   paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
}));

	  

export default function Types(props) {
  	const classes = useStyles();
  	const {handleSend} = props;
  	const [loaded, setLoaded] = React.useState(false);
	const [options, setOptions] = React.useState([]);
	const [item, setItem] = React.useState({});
	
  	//const [typesList, setTypesList] = React.useState([]);
	//const [btypesList, setBTypesList] = React.useState([]);
	//const [categories, setCategories] = React.useState([]);
	//const [catEdit, setCatEdit] = React.useState(false);
	//const [cat, setCat] = React.useState({});
	//const [signClass, setSignClass] = React.useState({});
	//const [classEdit, setClassEdit] = React.useState(false);
	//const [typeEdit, setTypeEdit] = React.useState(false);
	//const [signType, setSignType] = React.useState({});
	const [edit, setEdit] = React.useState(false);
	//const [images, setImages] = React.useState([]);
	//const [tabNum, setTabNum] = React.useState(0);
	//const [menuAnchor, setMenuAnchor] = React.useState(null);
	//const [filters, setFilters] = React.useState({
	//	category : null,
	//	class : null
	//})
	//const menuOpen = Boolean(menuAnchor);
	
  	React.useEffect(() => {
		if(!loaded){
			getOptionsList();
		}
	});
  	const getOptionsList = () =>{
		setLoaded(true);
		handleSend({
			vso: 'ph5_settings'
		}, (data) => {
			setOptions(data.ph5_settings);
			//setImages(data.images);
		});
	}
	//when a tab is clicked
	//const handleChangeTab = (event, newValue) => {
		//console.log(newValue);
    //	setTabNum(newValue);
  	//};
	const handleNew = (event) => {
		//setMenuAnchor(event.currentTarget);
		//console.log(event);
		setItem({});
		if(edit){
			setEdit(false);
			setTimeout(()=>{setEdit(true)}, 200);
		} else {
			setEdit(true);
		}
		//setCatEdit(true);
		//setTabNum(1);
		//handleCloseMenu();
	}
	//const handleCloseMenu = () => {
	//	setMenuAnchor(null);
	//}
	//Set the transform origin variables for "new" menu
	//const menuOrigins = {
	//	vertical: 'top',
	//	horizontal: 'left'
	//};
	
	//Render Option form
	const renderOption = () => {
		
		if(edit){
			return (
				<Option
					item={item}
					handleSend={handleSend}
					onChange={handleUpdateItem}
				/>
			);
		}
		
		return '';
	};

	//After an item is saved
	const handleUpdateItem = (uitem, isNew) => {
		//if(item.pic){
		//	item.pic_path = images.filter(pic => pic.id === item.pic)[0].path;
		//}
		if(typeof uitem !== 'object'){
			//delete
			//setItem({});
			setEdit(false);
			getOptionsList();
			return;
		}
		setItem(uitem);
		if(isNew){
			options.push(uitem);
		} else {
			options.splice(options.findIndex(row => row.id === uitem.id), 1, uitem);
		}
		setOptions(options);
	}
	
	

	
	//Handle select item
	const handleSelectItem = (item) => {
		setEdit(true);
		setItem(item);
		console.log(item);
	}
	/*
	//Handle any filter changes
	const handleChangeFilter = (e) => {
		var name = e.target.name;
		var value = e.target.value;
		var myFilters = Object.assign({}, filters);
		myFilters[name] = value;
		setFilters(myFilters);
	}
	*/
	
	return (
		<div className={classes.root}>
			<AppBar position="static" color="default">
				<Box display="flex">
					<Button
						variant="contained"
						color="primary"
						onClick={handleNew}
						startIcon={<AddIcon />}
					>New Setting</Button>
				</Box>
			</AppBar>
			<Box p={3}>
				{renderOption()}
				<OptionTable handleSend={handleSend} items={options} onSelect={handleSelectItem} />
			</Box>
		</div>
  );
}
